import { useState, useEffect, useRef } from 'react';

import './Pagination.css';

import { PaginationProps, PagesComponentProps } from '../interfaces';

function Pagination({ entries, setEntries, totalEntries, page, setPage }:PaginationProps) {
  function handleSelectChange(event:React.ChangeEvent<HTMLSelectElement>) {
    setEntries(event.currentTarget.value);
    setPage(1);
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault(); 
  };

  return (
    <form aria-label="Paginierung" className="pagination-component" onSubmit={handleSubmit}>
      <div className="pagination">
        <div className="pagination-selection">
          <label htmlFor="entries-number">Ergebnisse pro Seite</label>
          <div>
            <select value={entries} id="entries-number" onChange={handleSelectChange}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value={totalEntries}>alle anzeigen</option>
            </select> 
          </div>
        </div>
        <PagesComponent totalEntries={totalEntries} entries={entries} page={page} setPage={setPage} />
      </div>
    </form>
  );
}

export default Pagination;

function PagesComponent({ totalEntries, entries, page, setPage }: PagesComponentProps) {
  const [inputPage, setInputPage] = useState(page);

  useEffect(() => {
    setInputPage(page);
  }, [page]);

  const pagesNumber:number = Math.ceil(totalEntries / entries);

  const pagesArr = [];

  for (let i = 1; i <= pagesNumber; i++) {
    pagesArr.push(i);
  }

  function handleButtonClick(selectedPage:number) {
    setPage(selectedPage); 
    setInputPage(selectedPage);
  }

  function handleInputChange(event:React.ChangeEvent<HTMLInputElement>) { 
    const input = parseInt(event.currentTarget.value);

    setInputPage(input);

    if (input >= 1 && input <= pagesNumber) {
      setPage(input);
    }      
  }

  return (
    <div>
      <label htmlFor="to-page">Gehe zu Seite</label>
      <div className="pagination-pages">
        <input type="number" id="to-page" value={inputPage} size={2} min={1} max={pagesNumber} onChange={handleInputChange} />
        <span>von {pagesNumber}</span>
        { /*
          pagesArr.map((p) => {
            if (p === page) {
              return (<button type="button" className="current-page button-as-link">{p}</button>);
            } 

            return (<button type="button" className="pages button-as-link" onClick={() => handleButtonClick(p)}>{p}</button>);
          })
        */ }
        <button 
          type="button" 
          className={`pages button-as-link previous-icon ${page === 1 ? 'invisible' : ''}`}
          data-text="vorherige" 
          onClick={() => handleButtonClick(page - 1)}
          title="zur vorherigen Seite springen"
        >
          vorherige
        </button>
        <button 
          type="button" 
          className={`pages button-as-link next-icon ${page === pagesNumber ? 'invisible' : ''}`} 
          data-text="nächste" 
          onClick={() => handleButtonClick(page + 1)}
          title="zur nächsten Seite springen"
        >
          nächste
        </button>
      </div>
    </div>
  );
}
